import { Ns } from '@admin/i18n/types';

import { AdminRoute } from './AdminRoute';

export const NamespacesByRoute: Record<AdminRoute, string[]> = {
    [AdminRoute.AdsTxt]: [Ns.AdsTxt],
    [AdminRoute.Ads]: [Ns.Ads],
    [AdminRoute.Advice]: [],
    [AdminRoute.Media]: [],

    [AdminRoute.AiPrompts]: [Ns.AiPrompts],
    [AdminRoute.AiResults]: [Ns.AiResults],
    [AdminRoute.Article]: [Ns.Articles, Ns.Poll],
    [AdminRoute.Articles]: [Ns.Articles],
    [AdminRoute.AuditLogs]: [Ns.AuditLogs],

    [AdminRoute.Banner]: [],
    [AdminRoute.BlockedDomain]: [Ns.BlockedDomain],
    [AdminRoute.BlockedIps]: [Ns.BlockedIps],
    [AdminRoute.Bookmakers]: [Ns.Bookmaker],
    [AdminRoute.Bottom]: [],

    [AdminRoute.CarouselHeadlines]: [],
    [AdminRoute.Config]: [Ns.Config, Ns.IpQs, Ns.Recaptcha],
    [AdminRoute.Comments]: [Ns.Comments, Ns.IpQs, Ns.Recaptcha],
    [AdminRoute.Curation]: [Ns.Curation],
    [AdminRoute.DeprecatedPaginas]: [],

    [AdminRoute.Experiments]: [Ns.Experiments],
    [AdminRoute.ExternalSnippets]: [Ns.Ads],
    [AdminRoute.Faqs]: [Ns.Faqs, Ns.FaqCategories],
    [AdminRoute.FilteredComments]: [Ns.FilteredComments],
    [AdminRoute.Flag]: [Ns.Comments],
    [AdminRoute.ForbiddenWords]: [Ns.ForbiddenWords],
    [AdminRoute.Gebruiker]: [Ns.User],
    [AdminRoute.Hoofdpagina]: [],
    [AdminRoute.Index]: [Ns.Articles],
    [AdminRoute.Jersey]: [],

    [AdminRoute.Link]: [],
    [AdminRoute.Links]: [],
    [AdminRoute.Liveness]: [],
    [AdminRoute.Logs]: [],

    [AdminRoute.MatchEvents]: [],
    [AdminRoute.MatchReports]: [Ns.MatchReports],
    [AdminRoute.MatchTicker]: [Ns.MatchTicker],
    [AdminRoute.ManageTags]: [],
    [AdminRoute.ManageTagContent]: [],
    [AdminRoute.MediaNews]: [],
    [AdminRoute.MediaVideofeed]: [Ns.Videofeed],
    [AdminRoute.ModuleSchedule]: [Ns.ModuleSchedule],
    [AdminRoute.NavItems]: [Ns.NavItems],
    [AdminRoute.NewsCategory]: [Ns.NewsCategory],
    [AdminRoute.NotificationBar]: [Ns.Notificationbar],
    [AdminRoute.OddsDossier]: [Ns.Oddsdossier, Ns.ModuleSchedule],
    [AdminRoute.OptaExports]: [Ns.OptaExports],

    [AdminRoute.PagesEdit]: [Ns.Pages],
    [AdminRoute.PagesNew]: [Ns.Pages],
    [AdminRoute.Pages]: [Ns.Pages, Ns.RichEditor],
    [AdminRoute.Poll]: [Ns.Poll],

    [AdminRoute.PropositionCreate]: [Ns.Propositions],
    [AdminRoute.PropositionDuplicate]: [Ns.Propositions],
    [AdminRoute.Propositions]: [],
    [AdminRoute.Proposition]: [Ns.Propositions],
    [AdminRoute.Redirects]: [Ns.Redirects],
    [AdminRoute.Rooster]: [],
    [AdminRoute.Sandbox]: [Ns.Sandbox],
    [AdminRoute.Stats]: [],
    [AdminRoute.SubscriptionGifts]: [],

    [AdminRoute.Tags]: [Ns.Tags, Ns.Meta],
    [AdminRoute.TagsContent]: [Ns.Tags, Ns.Meta],
    [AdminRoute.TagsDuplicate]: [Ns.Tags, Ns.Meta],
    [AdminRoute.TagsManage]: [Ns.Tags, Ns.Meta],
    [AdminRoute.TierCreate]: [Ns.Tiers],
    [AdminRoute.TierDuplicate]: [Ns.Tiers],
    [AdminRoute.TierGroups]: [Ns.TierGroups, Ns.Tiers, Ns.Propositions],
    [AdminRoute.Tier]: [Ns.Tiers],
    [AdminRoute.Tiers]: [Ns.Tiers],
    [AdminRoute.UserGeneratedContent]: [Ns.Articles],
    [AdminRoute.User]: [],
    [AdminRoute.Users]: [Ns.User],
};
